<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" class="w-4 h-4">
  <circle cx="12" cy="12" r="10" />
</svg>
